import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { SELLER_DETAILS_PAGE_NAME } from '@/components/pages/cabinet/routes'


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicationCard',
  props: {
  publication: Object,
  statuses: Object,
  colors: Object,
  detailsPageLink: {
    type: String,
    default: '',
  },
  updatePageLink: {
    type: String,
    default: '',
  },
},
  emits: ['select'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { $t } = useGlobal()
const emit = __emit
const props = __props
const { id, firstName, lastName, publishedAt, outlet, phone } = props.publication
const val = ref(false)

function setValue(val) {
  emit("select", props.publication)
}


const __returned__ = { $t, emit, props, id, firstName, lastName, publishedAt, outlet, phone, val, setValue, ref, get useGlobal() { return useGlobal }, get SELLER_DETAILS_PAGE_NAME() { return SELLER_DETAILS_PAGE_NAME } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})